<div class="outer-div" #outerDiv>

  <div *ngFor="let laderaum of laderaeume">
    <h1>{{ laderaum.label }}</h1>

    <div class="laderaum" [style.height]="laderaum.height">
      <div class="palette" *ngFor="let palette of laderaum.paletten"
           [style.backgroundColor]="palette.color"
           [style.width]="palette.width"
           [style.height]="palette.height"
           [style.left]="palette.left"
           [style.top]="palette.top">

           <!-- <div class="stellplatzLkw">{{ palette.auftrag.stellplatzLkw }}</div> -->
           <div class="name">{{ palette.auftrag.Info1 }}</div>
           <div class="name">{{ palette.auftrag.Info2 }}</div>
           <div class="name">{{ palette.auftrag.Info3 }}</div>
      </div>
    </div>
  </div>
</div>